/**
 * horseListSort.js — Tri de la liste « Mes Chevaux » (S2)
 *
 * Tri côté client : un propriétaire a au plus quelques chevaux, et l'ordre
 * doit suivre le sélecteur instantanément, sans aller-retour serveur.
 * Modes partagés avec le backend (enum User.preferences.horseListSort) via
 * shared/horseListSort.json, copie parité-testée.
 */
import horseListSortConfig from '../constants/horseListSort.json';

// Import par défaut : webpack refuse les imports nommés depuis un JSON
const { MODES, DEFAULT_MODE } = horseListSortConfig;

export const HORSE_LIST_SORT_MODES = MODES;
export const DEFAULT_HORSE_LIST_SORT = DEFAULT_MODE;

/** Mode connu, sinon le mode par défaut (préférence absente ou obsolète). */
export const normalizeSortMode = (mode) => (MODES.includes(mode) ? mode : DEFAULT_MODE);

const timeOf = (value) => {
  if (value === null || value === undefined) return null;
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? null : t;
};

// Absents en dernier quel que soit le sens : un cheval sans donnée n'est
// ni « le plus récent » ni « le plus ancien ».
const byTimeDesc = (a, b) => {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return b - a;
};

/**
 * @param {Array} horses
 * @param {string} mode lastData | nameAsc | nameDesc | createdDesc
 * @param {string} lang langue i18n active (ordre alphabétique localisé)
 * @returns {Array} nouvelle liste triée (l'entrée n'est pas modifiée)
 */
export function sortHorses(horses, mode, lang) {
  // sensitivity 'base' : « éclair », « Eclair » et « ECLAIR » sont égaux
  const collator = new Intl.Collator(lang || 'fr', { sensitivity: 'base' });
  const byName = (a, b) => collator.compare(a.horseName || '', b.horseName || '');

  const compare = {
    lastData:    (a, b) => byTimeDesc(timeOf(a.lastDataAt), timeOf(b.lastDataAt)) || byName(a, b),
    nameAsc:     (a, b) => byName(a, b),
    nameDesc:    (a, b) => byName(b, a),
    createdDesc: (a, b) => byTimeDesc(timeOf(a.createdAt), timeOf(b.createdAt)) || byName(a, b),
  }[normalizeSortMode(mode)];

  return [...(horses || [])].sort(compare);
}
